<template>
  <div>
    <el-form ref="AddForm" :model="AddForm" label-width="80px" :rules="AddRules" style="margin-top:10px;margin-bottom:60px;">
        <el-row type="flex" class="row-bg">
          <el-col :span="14">
            <el-form-item label="标题" prop="ha_title">
                <el-input v-model="AddForm.ha_title"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" class="row-bg">
          <el-col :span="14">
            <el-form-item label="简介" prop="ha_introduce">
                <el-input type="textarea" v-model="AddForm.ha_introduce" :rows="4" maxlength="400"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" class="row-bg">
          <el-col :span="14">
                <el-form-item label="内容111" prop="ha_content">
                    <!-- <quill-editor ref="AddTextEditor"
                        class="ql-editor"
                        v-model="AddForm.ha_content"
                        :options = "AddEditorOption"
                        style="width:800px;height:500px;overflow:scroll">
                    </quill-editor> -->
                    <vue-ueditor-wrap   @ready="onEditorReady"
                        v-model="AddForm.ha_content" 
                        :config="editorConfig">
                    </vue-ueditor-wrap>
                </el-form-item>
          </el-col>
        </el-row>
    </el-form>

    <el-footer>
        <el-button type="primary" @click="goBack" size="small" icon="el-icon-arrow-left">返回</el-button>
        <el-button type="primary" @click="AddSave('AddForm')" size="small" icon="el-icon-edit-outline">保存</el-button>
    </el-footer>
  </div>
</template>

<script>
// 引入接口
import api from '@/api/api.js'
// 获取token
import { getToken , removeToken } from '@/utils/auth'

// 引入ueditor
import VueUeditorWrap from 'vue-ueditor-wrap'

// 引入富文本框插件
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

export default {
  name: 'componentspage1',
  components : {
    quillEditor,
    VueUeditorWrap
  },
  data() {
      return {
          AddForm : {},

          AddRules : {
                ha_title : [{required: true,message : '请输入标题', trigger: 'blur'}],
                ha_content : [{required: true,message : '请输入内容', trigger: 'blur'}],
                ha_introduce : [{required: true,message : '请输入简介', trigger: 'blur'}],
            },

          AddEditorOption : {
          theme: 'snow',
          boundary: document.body, 
          modules: {
            toolbar: [
              ['bold', 'italic', 'underline', 'strike'],
              ['blockquote', 'code-block'],
              [{ 'header': 1 }, { 'header': 2 }],
              [{ 'list': 'ordered' }, { 'list': 'bullet' }],
              [{ 'script': 'sub' }, { 'script': 'super' }],
              [{ 'indent': '-1' }, { 'indent': '+1' }],
              [{ 'direction': 'rtl' }],
              [{ 'size': ['small', false, 'large', 'huge'] }],
              [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
              [{ 'color': [] }, { 'background': [] }],
              [{ 'font': [] }],
              [{ 'align': [] }],
              ['clean'],
              ['link', 'image', 'video']
            ]
          },
          placeholder: 'Insert text here ...',
          readOnly: false
        },

        editorConfig : {
            // 如果需要上传功能,找后端小伙伴要服务器接口地址
            // serverUrl: this.$config.baseUrl + 'ueditor/ueditorConfig',
            serverUrl: `${api.dev}/api/main/ueditor/ueditorConfig`,
            // 你的UEditor资源存放的路径,相对于打包后的index.html
            UEDITOR_HOME_URL: '/ueditor/',
            // UEDITOR_HOME_URL: '/ueditor/',
            // 编辑器不自动被内容撑高
            autoHeightEnabled: false,
            // 工具栏是否可以浮动
            autoFloatEnabled: false,
            // 初始容器高度
            initialFrameHeight: 520,
            // 初始容器宽度
            initialFrameWidth: 800,
            // 关闭自动保存
            enableAutoSave: true,
            toolbars: [[
                'fullscreen', 'source', '|', 'undo', 'redo', '|',
                'bold', 'italic', 'underline', 'fontborder', 'strikethrough', 'superscript', 'subscript', 'removeformat', 'formatmatch', 'autotypeset', 'blockquote', 'pasteplain', '|', 'forecolor', 'backcolor', 'insertorderedlist', 'insertunorderedlist', 'selectall', 'cleardoc', '|',
                'rowspacingtop', 'rowspacingbottom', 'lineheight', '|',
                'customstyle', 'paragraph', 'fontfamily', 'fontsize', '|',
                'directionalityltr', 'directionalityrtl', 'indent', '|',
                'justifyleft', 'justifycenter', 'justifyright', 'justifyjustify', '|', 'touppercase', 'tolowercase', '|',
                'link', 'unlink', 'anchor', '|', 'imagenone', 'imageleft', 'imageright', 'imagecenter', '|',
                'simpleupload', 'emotion', 'pagebreak', 'template', 'background', '|',
                'horizontal', 'date', 'time', 'spechars', 'snapscreen', 'wordimage', '|',
                'inserttable', 'deletetable', 'insertparagraphbeforetable', 'insertrow', 'deleterow', 'insertcol', 'deletecol', 'mergecells', 'mergeright', 'mergedown', 'splittocells', 'splittorows', 'splittocols', 'charts', '|',
                'print', 'preview', 'searchreplace', 'drafts', 'help'
            ]],
            },
      }
  },
  methods : {
      goBack() {
        this.$router.back(-1);
      },
      onEditorReady(editorInstance) {
      //  console.log(`编辑器实例${editorInstance.key}: `, editorInstance);     
      editorInstance.execCommand('serverparam', {'access_token': getToken()}); 
    },
      AddSave(formName) {
            this.$refs[formName].validate((valid) => {
                if(valid) {
                    // 开启加载器
                    const loading = this.$loading({
                        lock: true,
                        text: '正在保存中...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    var formdata = new FormData();
                    formdata.append('access_token',getToken());
                    formdata.append('ha_title',this.AddForm.ha_title);
                    formdata.append('ha_building',this.$route.params.bid);
                    formdata.append('ha_content',this.AddForm.ha_content);
                    formdata.append('ha_introduce',this.AddForm.ha_introduce);
                    this.$http.post(`${api.dev}/p/main/houseArticle/save`,formdata,{emulateJSON:true}).then(res => {
                        if(res.body.code == 200) {
                            loading.close();
                            this.$message({
                                message: res.body.msg,
                                type: 'success'
                            });
                            this.goBack();
                        }else if(res.body.code == 500) {
                            loading.close();
                            this.$message({
                                message: res.body.msg,
                                type: 'error'
                            });
                        }else if(res.body.code == 510) {
                            this.$message({
                                message: res.body.msg,
                                type: 'error'
                            });
                            removeToken();
                            setTimeout(function () {
                                this.$router.push({path: '/login'});
                            },2000)
                        }
                    })
                }else {
                    console.log('submit error');
                    return false;
                }
            })
      }
  },
  created() {
    //   this.getInfo()
  }
}
</script>

<style lang="stylus" scoped>
.el-footer 
    background-color #A3C0D1;
    color #333;
    line-height 60px;
    position absolute;
    width 100%;
    bottom 0;
    z-index 9999
    margin-left -15px
</style>
